require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./law-enforcement-aed.json") })
        }
      }, "path---law-enforcement-aed");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---law-enforcement-aed!./.cache/json/law-enforcement-aed.json
// module id = 922
// module chunks = 231608221292675